import { Rect } from '../../Rect';
import { ChartDimensions, Margin } from './types';

export const TICK_LENGTH = 6;
export const LABEL_MARGIN = 3;

export const labelHeight = 14;

export const DEFAULT_CHART_DIMENSIONS: ChartDimensions = {
  margin: { left: 0, right: 0, top: 0, bottom: 0 },
  container: Rect.EMPTY,
  chart: { width: 0, height: 0 },
};

export const DEFAULT_MARGIN: Margin = {
  top: 10,
  right: 20,
  bottom: 30,
  left: 50,
};

export const GRAPH_INSETS = 100;
